<template>
    <div v-if="drafts.length">
        <div v-for="item in drafts" :key="item.slug" class="card border-warning shadow-sm mb-3">
            <div class="card-body d-flex flex-column flex-sm-row align-items-sm-center">
                <div class="flex-grow-1 mb-2 mb-sm-0">
                    <div class="small text-muted text-uppercase">Continue where you left off</div>
                    <div class="font-weight-bold text-dark">{{ item.label }}</div>
                    <div class="small text-dark"><i class="las la-pause-circle text-warning"></i> {{ item.description }}</div>
                </div>
                <a :href="resumeUrl(item.slug)" class="btn btn-primary">
                    <i class="las la-play mr-1"></i>Continue
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { loadDraft, describeDraft } from '../../utils/assessmentDraft';

/**
 * Lists unfinished inspections saved on this device (see utils/assessmentDraft).
 */
export default {
    props: {
        houses: { type: Array, default: () => [] },
    },
    data() {
        return { drafts: [] };
    },
    mounted() {
        this.drafts = this.houses
            .map(house => ({ house, draft: loadDraft(house.slug) }))
            .filter(item => item.draft)
            .map(item => ({
                slug: item.house.slug,
                label: item.house.label,
                description: describeDraft(item.draft),
            }));
    },
    methods: {
        resumeUrl(slug) {
            return route('owner.assessments.selectHouse', { house: slug }) + '#inspect';
        },
    },
};
</script>
